// XXX CSS is used on Web, JavaScript styles are use only for mobile. Export an
// (empty) object so that styles[*] statements on Web don't trigger errors.
import BaseTheme from '../../../base/ui/components/BaseTheme';

export default {};

export const DROPBOX_LOGO = 'images/dropboxLogo_square.png';

export const ICON_CLOUD = 'images/icon-cloud.png';

export const JITSI_LOGO = 'images/jitsiLogo_square.png';

export const TRACK_COLOR = BaseTheme.palette.ui15;
